/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsCustomWarning
 */
export interface ControlcenterMelcoModelsCustomWarning {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsCustomWarning
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsCustomWarning
     */
    source?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsCustomWarning
     */
    message?: string | null;
}

export function ControlcenterMelcoModelsCustomWarningFromJSON(json: any): ControlcenterMelcoModelsCustomWarning {
    return ControlcenterMelcoModelsCustomWarningFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsCustomWarningFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsCustomWarning {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function ControlcenterMelcoModelsCustomWarningToJSON(value?: ControlcenterMelcoModelsCustomWarning | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'source': value.source,
        'message': value.message,
    };
}


